"use client";

import { useEffect, useState } from "react";
import { TierListCreationWizard } from "@/components/tier-list-creation-wizard";
import { TierListEditor } from "@/components/tier-list-editor";
import { MockTierList } from "@/components/mock-tier-list";
import { TierList } from "@/types/tier-list";
import { getLastUsedTierListId, getTierList } from "@/lib/indexdb";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

export default function Home() {
  const [tierList, setTierList] = useState<TierList | null>(null);
  const [loading, setLoading] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    loadTierList();
  }, []);

  const loadTierList = async () => {
    try {
      setLoading(true);
      const lastUsedId = await getLastUsedTierListId();

      if (lastUsedId) {
        const list = await getTierList(lastUsedId);
        if (list) {
          setTierList(list);
        } else {
          setShowCreateForm(true);
        }
      } else {
        setShowCreateForm(true);
      }
    } catch (error) {
      console.error("Failed to load tier list:", error);
      setShowCreateForm(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTierListCreated = async (tierListId: string) => {
    const list = await getTierList(tierListId);
    if (list) {
      setTierList(list);
      setShowCreateForm(false);
    }
  };

  const handleTierListChange = async (tierListId: string) => {
    const list = await getTierList(tierListId);
    if (list) {
      setTierList(list);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-zinc-950">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (showCreateForm || !tierList) {
    return (
      <div className="min-h-screen bg-zinc-950">
        <div className="pt-12">
          <MockTierList />
        </div>
        <Dialog open={true} onOpenChange={() => {}}>
          <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
            <TierListCreationWizard onSuccess={handleTierListCreated} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  return (
    <TierListEditor tierList={tierList} onTierListChange={handleTierListChange} />
  );
}
